const regions = {
    WEST: 'WEST',
    MIDWEST: 'MIDWEST',
    NORTHEAST: 'NORTHEAST',
    SOUTH: 'SOUTH',
};

export const regionList = {
    [regions.WEST]: {
        label: 'West',
        subregions: [
            { name: 'Alaska', abbr: 'AK' },
            { name: 'Arizona', abbr: 'AZ' },
            { name: 'California', abbr: 'CA' },
            { name: 'Colorado', abbr: 'CO' },
            { name: 'Hawaii', abbr: 'HI' },
            { name: 'Idaho', abbr: 'ID' },
            { name: 'Montana', abbr: 'MT' },
            { name: 'Nevada', abbr: 'NV' },
            { name: 'New Mexico', abbr: 'NM' },
            { name: 'Oregon', abbr: 'OR' },
            { name: 'Utah', abbr: 'UT' },
            { name: 'Washington', abbr: 'WA' },
            { name: 'Wyoming', abbr: 'WY' },
        ],
    },
    [regions.MIDWEST]: {
        label: 'Midwest',
        subregions: [
            { name: 'Illinois', abbr: 'IL' },
            { name: 'Indiana', abbr: 'IN' },
            { name: 'Iowa', abbr: 'IA' },
            { name: 'Kansas', abbr: 'KS' },
            { name: 'Michigan', abbr: 'MI' },
            { name: 'Minnesota', abbr: 'MN' },
            { name: 'Missouri', abbr: 'MO' },
            { name: 'Nebraska', abbr: 'NE' },
            { name: 'North Dakota', abbr: 'ND' },
            { name: 'Ohio', abbr: 'OH' },
            { name: 'South Dakota', abbr: 'SD' },
            { name: 'Wisconsin', abbr: 'WI' },
        ],
    },
    [regions.NORTHEAST]: {
        label: 'Northeast',
        subregions: [
            { name: 'Connecticut', abbr: 'CT' },
            { name: 'Maine', abbr: 'ME' },
            { name: 'Massachusetts', abbr: 'MA' },
            { name: 'New Hampshire', abbr: 'NH' },
            { name: 'New Jersey', abbr: 'NJ' },
            { name: 'New York', abbr: 'NY' },
            { name: 'Pennsylvania', abbr: 'PA' },
            { name: 'Rhode Island', abbr: 'RI' },
            { name: 'Vermont', abbr: 'VT' },
        ],
    },
    [regions.SOUTH]: {
        label: 'South',
        subregions: [
            { name: 'Alabama', abbr: 'AL' },
            { name: 'Arkansas', abbr: 'AR' },
            { name: 'Delaware', abbr: 'DE' },
            { name: 'Florida', abbr: 'FL' },
            { name: 'Georgia', abbr: 'GA' },
            { name: 'Kentucky', abbr: 'KY' },
            { name: 'Louisiana', abbr: 'LA' },
            { name: 'Maryland', abbr: 'MD' },
            { name: 'Mississippi', abbr: 'MS' },
            { name: 'North Carolina', abbr: 'NC' },
            { name: 'Oklahoma', abbr: 'OK' },
            { name: 'South Carolina', abbr: 'SC' },
            { name: 'Tennessee', abbr: 'TN' },
            { name: 'Texas', abbr: 'TX' },
            { name: 'Virginia', abbr: 'VA' },
            { name: 'Washington D.C.', abbr: 'DC' },
            { name: 'West Virginia', abbr: 'WV' },
        ],
    },
    CANADA: { label: 'Canada' },
    INTERNATIONAL: {
        label: 'International (Anything outside US and CA)',
    },
};

export const statesWithRegions = [
    // West
    { name: 'Alaska', abbr: 'AK', region: regions.WEST },
    { name: 'Arizona', abbr: 'AZ', region: regions.WEST },
    { name: 'California', abbr: 'CA', region: regions.WEST },
    { name: 'Colorado', abbr: 'CO', region: regions.WEST },
    { name: 'Hawaii', abbr: 'HI', region: regions.WEST },
    { name: 'Idaho', abbr: 'ID', region: regions.WEST },
    { name: 'Montana', abbr: 'MT', region: regions.WEST },
    { name: 'Nevada', abbr: 'NV', region: regions.WEST },
    { name: 'New Mexico', abbr: 'NM', region: regions.WEST },
    { name: 'Oregon', abbr: 'OR', region: regions.WEST },
    { name: 'Utah', abbr: 'UT', region: regions.WEST },
    { name: 'Washington', abbr: 'WA', region: regions.WEST },
    { name: 'Wyoming', abbr: 'WY', region: regions.WEST },

    // Midwest
    { name: 'Illinois', abbr: 'IL', region: regions.MIDWEST },
    { name: 'Indiana', abbr: 'IN', region: regions.MIDWEST },
    { name: 'Iowa', abbr: 'IA', region: regions.MIDWEST },
    { name: 'Kansas', abbr: 'KS', region: regions.MIDWEST },
    { name: 'Michigan', abbr: 'MI', region: regions.MIDWEST },
    { name: 'Minnesota', abbr: 'MN', region: regions.MIDWEST },
    { name: 'Missouri', abbr: 'MO', region: regions.MIDWEST },
    { name: 'Nebraska', abbr: 'NE', region: regions.MIDWEST },
    { name: 'North Dakota', abbr: 'ND', region: regions.MIDWEST },
    { name: 'Ohio', abbr: 'OH', region: regions.MIDWEST },
    { name: 'South Dakota', abbr: 'SD', region: regions.MIDWEST },
    { name: 'Wisconsin', abbr: 'WI', region: regions.MIDWEST },

    // Northeast
    { name: 'Connecticut', abbr: 'CT', region: regions.NORTHEAST },
    { name: 'Maine', abbr: 'ME', region: regions.NORTHEAST },
    { name: 'Massachusetts', abbr: 'MA', region: regions.NORTHEAST },
    { name: 'New Hampshire', abbr: 'NH', region: regions.NORTHEAST },
    { name: 'New Jersey', abbr: 'NJ', region: regions.NORTHEAST },
    { name: 'New York', abbr: 'NY', region: regions.NORTHEAST },
    { name: 'Pennsylvania', abbr: 'PA', region: regions.NORTHEAST },
    { name: 'Rhode Island', abbr: 'RI', region: regions.NORTHEAST },
    { name: 'Vermont', abbr: 'VT', region: regions.NORTHEAST },

    // South
    { name: 'Alabama', abbr: 'AL', region: regions.SOUTH },
    { name: 'Arkansas', abbr: 'AR', region: regions.SOUTH },
    { name: 'Delaware', abbr: 'DE', region: regions.SOUTH },
    { name: 'Florida', abbr: 'FL', region: regions.SOUTH },
    { name: 'Georgia', abbr: 'GA', region: regions.SOUTH },
    { name: 'Kentucky', abbr: 'KY', region: regions.SOUTH },
    { name: 'Louisiana', abbr: 'LA', region: regions.SOUTH },
    { name: 'Maryland', abbr: 'MD', region: regions.SOUTH },
    { name: 'Mississippi', abbr: 'MS', region: regions.SOUTH },
    { name: 'North Carolina', abbr: 'NC', region: regions.SOUTH },
    { name: 'Oklahoma', abbr: 'OK', region: regions.SOUTH },
    { name: 'South Carolina', abbr: 'SC', region: regions.SOUTH },
    { name: 'Tennessee', abbr: 'TN', region: regions.SOUTH },
    { name: 'Texas', abbr: 'TX', region: regions.SOUTH },
    { name: 'Virginia', abbr: 'VA', region: regions.SOUTH },
    { name: 'Washington D.C.', abbr: 'DC', region: regions.SOUTH },
    { name: 'West Virginia', abbr: 'WV', region: regions.SOUTH },
];

export const getStatesInSameRegion = state => {
    const foundState = statesWithRegions.find(s => s.abbr === state);
    if (!foundState) {
        return [];
    }

    const region = regionList[foundState.region];
    if (!region) {
        return [];
    }

    return region.subregions;
};
